import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

class Droplist extends Component {
  static displayName = 'Droplist';
  static propTypes = {
    items: PropTypes.array.isRequired,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    title: PropTypes.string,
    showCaret: PropTypes.bool,
    hideItems: PropTypes.func
  };
  static defaultProps = {
    showCaret: false,
    hideItems: () => {}
  };
  render() {
    var { title, items, className, itemClassName, hideItems } = this.props;
    className = classnames('droplist', className);
    itemClassName = classnames('item', itemClassName);

    if (title) {
      var itemsTitle = <span className="droplist-title">{title}</span>;
      items.unshift(itemsTitle);
    }

    items = items.map(function (item, index) {
      const isListTitle = item.props?.className === 'droplist-title';
      const classes = classnames(itemClassName, {
        'droplist-title': isListTitle || (title && index === 0)
      });

      return (
        <li className={classes} key={index} onClick={isListTitle ? () => {} : hideItems}>
          {item}
        </li>
      );
    });

    return (
      <div className="droplist-container">
        <ul className={className}>
          {this.props.showCaret && <span className="caret" />}
          {items}
        </ul>
      </div>
    );
  }
}

export default Droplist;
